import { BaseModel } from "../base-model";

export type KorfineAttachmentSection = "OWNER" | "OWNERPARTNER" | "TENANT" | "TENANTPARTNER";
export interface IKorfineAttachment { Filename: string; FileUrl: string; }
export type IKorfineAttachments = Partial<Record<KorfineAttachmentSection, IKorfineAttachment[]>>;
export type IKorfineAttachmentsLoading = Partial<Record<KorfineAttachmentSection, boolean>>;
export interface IKorfineContractDocument { DocumentType: string; FileName: string; FileUrl: string; }

export interface IKorfineRequestModel{
    ObjectId?: number,
    ObjectIdent?: string,
    SupplierName?: any,
    CustomerName?: any,
    CustomerPass?: any,
    LanguageKey?: number,
    SecretKey?: any,
    UserId?: number,
    UserName?: any,
    UserSiteId?: number,
    Contract?: IKorfineContractModel,
    Attachments?: IKorfineAttachments,
    AttachmentsLoading?: IKorfineAttachmentsLoading
}

export class KorfineRequestModel extends BaseModel<IKorfineRequestModel> implements IKorfineRequestModel {
    ObjectId?: number;
    ObjectIdent?: string;
    SupplierName?: any;
    CustomerName?: any;
    CustomerPass?: any;
    LanguageKey?: number;
    SecretKey?: any;
    UserId?: number;
    UserName?: any;
    UserSiteId?: number;
    Contract?: IKorfineContractModel;
    Attachments?: IKorfineAttachments;
    AttachmentsLoading?: IKorfineAttachmentsLoading;

    constructor(option?: KorfineRequestModel) {
        super(option);
    }
}

export interface IKorfineContractModel {
    TypeOfContract?: string,
    Status?: string,
    DepositType?: string,
    Type?: string,
    Amount?: number,
    BasicRentPrice?: number,
    NumberOfMonths?: string,
    DateOfContract?: string,
    DateOfEntry?: string,
    OwnerReference?: string,
    Owner?: IKorfineOwner,
    Partner?: any,
    Tenant?: IKorfineTenant,
    EstateReference?: any,
    TenantReference?: any,
    Estate?: IKorfineEstate,
    Document?: IKorfineContractDocument[] | null,
    DocumentReference?: any,
    BusinessConnectReference?: string,
    X_Api_Key?: string,
    OwnerPersonId?: any,
    TenantPersonId?: any,
}

export class KorfineContractModel extends BaseModel<IKorfineContractModel> implements IKorfineContractModel {
    TypeOfContract?: string;
    Status?: string;
    DepositType?: string;
    Type?: string;
    Amount?: number;
    BasicRentPrice?: number;
    NumberOfMonths?: string;
    DateOfContract?: string;
    DateOfEntry?: string;
    OwnerReference?: string;
    Owner?: IKorfineOwner;
    Partner?: any;
    Tenant?: IKorfineTenant;
    EstateReference?: any;
    TenantReference?: any;
    Estate?: IKorfineEstate;
    Document?: IKorfineContractDocument[] | null;
    DocumentReference?: any;
    BusinessConnectReference?: string;
    X_Api_Key?: string;
    OwnerPersonId?: any;
    TenantPersonId?: any;

    constructor(option?: IKorfineContractModel) {
        super(option);
    }
}

export interface IKorfineOwner{
    Reference?: string,
    Category?: string,
    TaxResidenceBelgium?: boolean,
    IsPoliticalImportantPerson?: boolean,
    TaxResidenceCountries?: any,
    TaxResidenceNumbers?: any,
    Person?: IKorfinePerson,
    Partner?: IKorfinePerson,
    TaxResidences?: any
}

export class KorfineOwner extends BaseModel<IKorfineOwner> implements IKorfineOwner {
    constructor(option?: IKorfineOwner) {
        super(option);
    }
}

export interface IKorfineTenant{
    Reference?: any,
    Category?: string,
    TaxResidenceBelgium?: boolean,
    IsPoliticalImportantPerson?: boolean,
    TaxResidenceCountries?: any,
    TaxResidenceNumbers?: any,
    Person?: IKorfinePerson,
    Partner?: IKorfinePerson,
    TaxResidences?: any
}

export class KorfineTenant extends BaseModel<IKorfineTenant> implements IKorfineTenant {
    constructor(option?: IKorfineTenant) {
        super(option);
    }
}

export interface IKorfineEstate{
    Reference?: any,
    Category?: string,
    Sort?: string,
    Characterisation?: string,
    Street?: string,
    HouseNumber?: string,
    HouseNumberExtension?: any,
    Mailbox?: string,
    City?: string,
    Zipcode?: string,
    Country?: string,
    FloorLevel?: string,
    SurfaceLivable?: string,
    Cellar?: boolean,
    Attic?: boolean,
    ExtraBuildings?: boolean,
    NumberOfMonths?: string
}

export class KorfineEstate extends BaseModel<IKorfineEstate> implements IKorfineEstate {
    constructor(option?: IKorfineEstate) {
        super(option);
    }
}

export interface IKorfinePerson{
    Name?: string,
    FirstName?: string,
    CompanyName?: string,
    Street?: string,
    HouseNumber?: string,
    HouseNumberExtension?: any,
    Mailbox?: string,
    Residence?: any,
    City?: string,
    Zipcode?: string,
    Country?: string,
    Language?: string,
    Email?: string,
    Cellphone?: string,
    Phone?: string,
    DateOfBirth?: string,
    PlaceOfBirth?: string,
    Nationality?: string,
    NationalRegistryNumber?: string,
    // Korfine's enterprise (company) number field, sent with its country code (e.g. BE0123456789).
    RegistrationNumber?: string,
    IdCardExpirationDate?: any
}

export class KorfinePerson extends BaseModel<IKorfinePerson> implements IKorfinePerson {
    constructor(option?: IKorfinePerson) {
        super(option);
    }
}